export default class StorageService {
    supported = false;
    tokenPrefix = process.env.VUE_APP_TOKEN_PREFIX;

    constructor() {
        if (typeof (window.sessionStorage) !== 'undefined') {
            this.supported = true;
        }
    }

    get = (key,ignorePrefix = false) => {
        if (!this.supported) {
            return;
        }
    
        if (!key) {
            return null;
        }
        if(ignorePrefix) return window.sessionStorage.getItem(`${key}`);
        return window.sessionStorage.getItem(`${this.tokenPrefix}${key}`);
    };
    
    set = (key, value) => {
        if (!this.supported) {
            return;
        }
    
        if (!key || !value) {
            return;
        }
    
        window.sessionStorage.setItem(`${this.tokenPrefix}${key}`, value);
    };
    
    remove = (key) => {
        if (!this.supported) {
            return;
        }
    
        if (!key) {
            return;
        }
    
        window.sessionStorage.removeItem(`${this.tokenPrefix}${key}`);
    };
    
    clearAll = () => {
        if (!this.supported) {
            return;
        }
        for (const key in window.sessionStorage) {
        if (key.startsWith(this.tokenPrefix)) {
            window.sessionStorage.removeItem(key);
        }
    }
    };
    
    clearAllwithSuffix = (suffix) => {
        if (!this.supported) {
            return;
        }
    
        if (!suffix || !suffix.length) {
            return;
        }
    
        const suffixLength = suffix.length;
        for (const key in window.sessionStorage) {
            if (key.slice(-1 * suffixLength) === suffix) {
                this.remove(key);
            }
        }
    };


}
